/* Built In Imports */
/* External Imports */

import { Box } from "@chakra-ui/react";
import MediaEmbedV3 from "@components/Embeds/MediaEmbedV3";
import SectionTitle from "@components/Headings/SectionTitle";
import TopKolam from "@components/Headings/TopKolam";
import SingleLineText from '@components/UI/SingleLineText';
import config from '@config';

/* Internal Imports */
/* Components */

/**
 * Returns the BenefitsGroup.
 * @param {Object} sectionContent - Content from API
 * @param {string} language - Language of the page
 * @param {string} region - Region of the page
 * @returns {ReactElement} Banner component
 */
const SneakPeakV2 = ({ sectionContent, region, language }) => {
    return (
        <Box 
                    bgImage={{base:'', md:`url(${config.imgPath}/d/46272/1734709291-hytt_right_top_img.png)`}} 
                    bgRepeat={'no-repeat'}
                    bgPosition={'right 10%'}
                    width={'100%'}
                >
        <Box paddingTop={"0px"} >
            {sectionContent.map((section, index) => {
                if (section?._modelApiKey === 'section_title') {
                    return (
                        <Box key={index}

                        >
                            <SectionTitle
                                width={{ sm: "282px", base: "282px", md: "430px" }}
                                titleObj={section}
                                titleDecoration="none"
                                color="black"
                                fontSize={{ base: "30px", sm: "30px", md: "38px" }}
                                lineHeight={{ base: "37px", sm: "37px", md: "38px" }}
                                marginTop={{ sm: "-20px", base: "-20px", md: "5%", lg:"5%" }}
                                mx={{ base: 'auto', md: 'auto' }}

                            />
                        </Box>
                    );
                }
                if (section?._modelApiKey === 'single_line_text') {
                    return (
                        <Box 
                            //paddingBottom={'20px'}
                            width={{ sm: "250px", base: "250px", md: "380px" }}
                            mx={"auto"}
                            fontFamily={'FedraSansStd-book'}
                            fontSize={'18px'}
                            fontWeight={'350'}
                            color="#262626"
                            textAlign="center"
                            lineHeight={'25.2px'}
                            marginTop={'-15px'}

                            >
                            {sectionContent[1].text}
                        </Box>
                    )
                }

                if (section?._modelApiKey === 'top_kolam') {
                    return (
                        <Box key={index} marginTop={"-20px"}>
                            <TopKolam
                                sectionContent={section}
                            />
                        </Box>
                    )
                }

                if (section?._modelApiKey === 'media_embed_v2') {
                    return (
                        <Box
                            pos={'relative'}
                            maxWidth={'678px'}
                            margin={{ base: '20px auto', sm: "20px auto", md: "30px auto" ,lg: "30px auto"}}
                            paddingBottom={{base:'15%', sm:"15%", lg:"5%", md:"5%"}}
                            w={{ base: '90%' }}
                        >
                            <MediaEmbedV3 sectionContent={section} lang={language}
                                //width={{ base: '100%', md: '678px' }} txtcolor={'black'} 
                                boxShadow = '#262626 0px 20px 30px -15px'
                            />
                        </Box>
                    )
                }

            })}
        </Box>
        </Box>

    );
};

export default SneakPeakV2;
